import ModalFormController from "../../../../javascript/stimulusControllers/modals/modal-form-controller";

export default class extends ModalFormController {

  handleSuccessfulFormSubmission(event, data) {
    super.handleSuccessfulFormSubmission(event, data)
    App.QuickAdd.executeAfterQuickAdd(data)
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/assets/javascript/forms-modal-form-controller.js